import { InputInterface, TypeInput } from '../../types/Exa_Input'
import { PartieFormulaireInterface, TypePartie } from '../../types/Exa_PartieFormulaire'

/* eslint-disable @typescript-eslint/no-explicit-any */
export const namespaced = true


export const state: PartieFormulaireInterface = {
    id: 0,
    type: TypePartie.TYPE_MANUEL,
    ref: '',
    libelle: '',
    ordre: 0,
    inputs: [],
    inputSelect: null,
    json: '',
    jsonValues: '',
    tempInputId: null,
    condition: null,
    description: '',
    data: null,
    value: null
}

export const mutations = {
    RESET_STATE (state: PartieFormulaireInterface) {
        Object.assign(state, {
            type: TypePartie.TYPE_MANUEL,
            ref: '',
            id: 0,
            libelle: '',
            ordre: 0,
            inputs: [],
            inputSelect: null,
            json: '',
            jsonValues: '',
            tempInputId: null,
            condition: null,
            description: '',
            data: null,
            value: null
        })
    },
    SET_ID (state: PartieFormulaireInterface, id: number) {
        state.id = id
    },
    SET_REF (state: PartieFormulaireInterface, ref: string) {
        state.ref = ref
    },
    SET_INPUTS (state: PartieFormulaireInterface, inputs: Array<InputInterface>) {
        state.inputs = inputs
    },
    SET_LIBELLE (state: PartieFormulaireInterface, libelle: string) {
        state.libelle = libelle
    },
    SET_DESCRIPTION (state: PartieFormulaireInterface, description: string) {
        state.description = description !== null ? description : ''
    },
    SET_ORDRE (state: PartieFormulaireInterface, ordre: number) {
        state.ordre = ordre
    },
    SET_INPUT_SELECT(state: PartieFormulaireInterface, input: InputInterface) {
        state.inputSelect = input
    },
    SAVE_INPUT_SELECT(state: PartieFormulaireInterface, newInputId: number) {
        if (state.inputSelect) {
            if (state.inputSelect.id !== 0) {
                for (let i = 0; i < state.inputs.length; i++) {
                    if (Number(state.inputs[i].id) === Number(state.inputSelect.id)) {
                        state.inputs[i] = state.inputSelect
                        state.tempInputId = state.inputSelect.id
                    }
                }
            } else {
                if (Number(state.inputSelect.id) === 0) {
                    /*
                    let idTemp = 0
                    for (let i = 0; i < state.inputs.length; i++) {
                        if (state.inputs[i].id >= idTemp) {
                            idTemp = state.inputs[i].id + 1
                        }
                    }
                    */
                    state.inputSelect.id = newInputId;
                    (state.inputs as Array<InputInterface>).push(state.inputSelect)
                    state.tempInputId = newInputId
                }
            } 
        }
    },
    REMOVE_INPUT_SELECT(state: PartieFormulaireInterface) {
        if (state.inputSelect) {
            const inputsTemp: Array<InputInterface> = []
            for (let i = 0; i < state.inputs.length; i++) {
                if (Number(state.inputs[i].id) !== Number(state.inputSelect.id)) {
                    inputsTemp.push(state.inputs[i])
                }
            }
            for (let j = 0; j < inputsTemp.length; j++) {
                inputsTemp[j].ordre = j
            }
            state.inputs = inputsTemp
            state.inputSelect = null
        }
    },
    REMOVE_INPUT_BY_ID(state: PartieFormulaireInterface, input_id: number) {
        const inputsTemp: Array<InputInterface> = []
        for (let i = 0; i < state.inputs.length; i++) {
            if (Number(state.inputs[i].id) !== Number(input_id)) {
                inputsTemp.push(state.inputs[i])
            }
        }
        for (let j = 0; j < inputsTemp.length; j++) {
            inputsTemp[j].ordre = j
        }
        state.inputs = inputsTemp
    },
    ADD_INPUT(state: PartieFormulaireInterface, newInput: InputInterface) {
        newInput.ordre = state.inputs.length
        state.inputSelect = newInput
    },
    SET_ORDER_INPUTS(state: PartieFormulaireInterface, data: any) {
        const inputTemp = state.inputs.find((inputTmp: InputInterface) => Number(inputTmp.id) === Number(state.tempInputId))
        if (inputTemp) {
            const inputsTemp = []
            for (let i = 0; i < state.inputs.length; i++) {
                if (Number(state.inputs[i].id) !== Number(inputTemp.id) && Number(state.inputs[i].id) !== Number(data.markedInputId)) {
                    state.inputs[i].ordre = Number(inputsTemp.length)
                    inputsTemp.push(state.inputs[i])
                } else if (Number(state.inputs[i].id) === Number(data.markedInputId)) {
                    if (data.way === 'before') {
                        inputTemp.ordre = inputsTemp.length
                        inputsTemp.push(inputTemp)
                        state.inputs[i].ordre = inputsTemp.length
                        inputsTemp.push(state.inputs[i])
                    } else if (data.way === 'after') {
                        state.inputs[i].ordre = inputsTemp.length
                        inputsTemp.push(state.inputs[i])
                        inputTemp.ordre = inputsTemp.length
                        inputsTemp.push(inputTemp)
                    }
                }
            }
            inputsTemp.sort((a: InputInterface, b: InputInterface) => Number(a.ordre) > Number(b.ordre) ? 1 : (Number(a.ordre) < Number(b.ordre) ? -1 : 0))
            state.inputs = []
            state.inputs = inputsTemp
        }
    },
    UPDATE_JSON(state: PartieFormulaireInterface) {
        const inputs = []
        for (let i = 0; i < state.inputs.length; i++) {
            inputs.push({
                id: state.inputs[i].id,
                ref: state.inputs[i].ref,
                libelle: state.inputs[i].libelle,
                description: state.inputs[i].description,
                ordre: state.inputs[i].ordre,
                data: state.inputs[i].data
            })
        }
        state.json = JSON.stringify({
            id: state.id,
            ref: state.ref,
            type: state.type,
            libelle: state.libelle,
            description: state.description,
            ordre: state.ordre,
            condition: state.condition,
            inputs: inputs,
            data:state.data
        })
    },
    UPDATE_JSON_VALUES(state: PartieFormulaireInterface) {
        const inputs = []
        for (let i = 0; i < state.inputs.length; i++) {
            inputs.push({
                id: state.inputs[i].id,
                ref: state.inputs[i].ref,
                libelle: state.inputs[i].libelle,
                description: state.inputs[i].description,
                ordre: state.inputs[i].ordre,
                data: state.inputs[i].data
            })
        }
        state.json = JSON.stringify({
            id: state.id,
            ref: state.ref,
            type: state.type,
            libelle: state.libelle,
            description: state.description,
            ordre: state.ordre,
            condition: state.condition,
            inputs: inputs,
            data: state.data
        })
    },
    SET_INPUT_VALUE(state: PartieFormulaireInterface, data: any) {
        const currentInput = state.inputs.find((inputTemp: InputInterface) => inputTemp.id === data.ident)
        if (currentInput) {
            currentInput.value = data.value
        }
    },
    SET_INPUT_ANOMALIE(state: PartieFormulaireInterface, data: any) {
        const currentInput = state.inputs.find((inputTemp: InputInterface) => inputTemp.id === data.ident)
        if (currentInput) {
            currentInput.anomalie = data.anomalie
        }
    },
    SET_CONDITION (state: any, condition: any) {
        state.condition = condition
    }  
}

export const actions = {
    loadPartieFormulaire({ commit }: { commit: any }, partieFormulaire: PartieFormulaireInterface) {
        commit('SET_ID', partieFormulaire.id)
        commit('SET_REF', partieFormulaire.ref)
        commit('SET_INPUTS', partieFormulaire.inputs)
        commit('SET_LIBELLE', partieFormulaire.libelle)
        commit('SET_DESCRIPTION', partieFormulaire.description)
        commit('SET_ORDRE', partieFormulaire.ordre)
        commit('SET_CONDITION', partieFormulaire.condition)
    },
    setInputSelect({ commit }: { commit: any }, input: InputInterface) {
        commit('SET_INPUT_SELECT', JSON.parse(JSON.stringify(input)))
    },
    saveInputSelect({ commit }: { commit: any },  newInputId: number) {
        commit('SAVE_INPUT_SELECT', newInputId)
    },
    removeInputSelect({ commit }: { commit: any }) {
        commit('REMOVE_INPUT_SELECT')
    },
    removeInputById({ commit }: { commit: any }, input_id: number) {
        commit('REMOVE_INPUT_BY_ID', input_id)
    },
    addInput({ commit }: { commit: any }) {
        const newInput: InputInterface = {
            id: 0,
            libelle: '',
            ref: '',
            ordre: 0,
            requis: false,
            data: {
            },
            type: TypeInput.TYPE_TEXT,
            condition: null,
            value: null,
            description: '',
            anomalie: ''
        }
        commit('ADD_INPUT', newInput)
    },
    setOrderInputs({ commit }: { commit: any }, data: any) {
        commit('SET_ORDER_INPUTS', data)
    },
    updateJson({ commit }: { commit: any }) {
        commit('UPDATE_JSON')
    },
    updateJsonValues({ commit }: { commit: any }) {
        commit('UPDATE_JSON_VALUES')
    },
    setInputValue({ commit }: { commit: any }, data: any) {
        commit('SET_INPUT_VALUE', data)
    },
    setInputAnomalie({ commit }: { commit: any }, data: any) {
        commit('SET_INPUT_ANOMALIE', data)
    }
}

export const getters = {
    inputs: (state: PartieFormulaireInterface) => {
        return state.inputs
    },
    libelle: (state: PartieFormulaireInterface) => {
        return state.libelle
    },
    ref: (state: PartieFormulaireInterface) => {
        return state.ref
    },
    description: (state: PartieFormulaireInterface) => {
        return state.description
    },
    ordre: (state: PartieFormulaireInterface) => {
        return state.ordre
    },
    inputSelect: (state: PartieFormulaireInterface) => {
        return state.inputSelect
    },
    getInputById: (state: PartieFormulaireInterface) => (input_id: number) => {
        return state.inputs.find((inputTmp: InputInterface) => Number(inputTmp.id) === Number(input_id))
    },
    getJson: (state: PartieFormulaireInterface) => {
        return state.json
    },
    condition: (state: PartieFormulaireInterface) => {
        return state.condition
    }
}
